import React from 'react';
import { NAV_MARKS, type NavMarkName } from './navMarks';

/**
 * A stamped mark on a folder tab.
 *
 * The drawings on the empty desks are engravings — contour and cross-hatching —
 * and they are drawn for 40px and up. A folder tab needs a mark at 16–18px,
 * where a thin line disappears and hatching fills in. So these are cut the other
 * way: one solid mass per mark with the detail knocked out in negative space, the
 * way a rubber stamp works. No strokes at all, so nothing thins as it shrinks.
 *
 * That is not two styles by accident. The desk already has both a pen and a
 * stamp, and this is the stamp: the tab is the folder's label, and a label gets
 * stamped, not drawn.
 *
 * The mass takes currentColor, so a mark prints in its folder's light tint on the
 * navy board and takes the chapter's full tone once its folder is pulled forward.
 *
 * `br-mark` is the base and it is the same everywhere: 17px, full strength,
 * currentColor. The tint-on-navy lighting belongs to `.br-workspace-nav .br-mark`
 * and nothing else — put that on the base class and every mark elsewhere in the
 * app inherits the board's lighting.
 */
export default function NavMark({ name, className = '' }: { name: NavMarkName; className?: string }) {
  return (
    <svg className={`br-mark ${className}`} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={NAV_MARKS[name]} fill="currentColor" fillRule="evenodd" />
    </svg>
  );
}

export type { NavMarkName };
